module.exports = [{
      plugin: require('/Volumes/Untitled/repos/streamparrots-marketing-site/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":700},
    },{
      plugin: require('/Volumes/Untitled/repos/streamparrots-marketing-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
